import { render, staticRenderFns } from "./FormRectangle.vue?vue&type=template&id=57e812d8&scoped=true&"
import script from "./FormRectangle.vue?vue&type=script&lang=js&"
export * from "./FormRectangle.vue?vue&type=script&lang=js&"
import style0 from "./FormRectangle.vue?vue&type=style&index=0&id=57e812d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e812d8",
  null
  
)

export default component.exports